<template lang="pug">
span(v-if="showLabel")
  label.custom-file-upload(for="file-upload")
    input#file-upload(
      ref="fileInput"
      type="file"
      :accept="accept"
      @change="handleFileChange($event)"
    )
    slot(name="uploadText")
span(v-else)
  input.upload(
    ref="fileInput"
    type="file"
    :accept="accept"
    @change="handleFileChange($event)"
  )
</template>

<script>
export default {
  props: {
    accept: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: File,
    };
  },
  methods: {
    handleFileChange(e) {
      this.value = e.target.files[0];
      this.$emit('input', this.value);
    },
    reset() {
      this.$refs.fileInput.value = '';
      this.value = '';
    },
  },
};
</script>
